import React from 'react';
import {FastField} from "formik";
import {Grid} from "@material-ui/core";
import AreaSelectorContainer from 'data/redux/containers/areaSelectorContainer';
import PlaceSelector from 'gui/components/editors/commons/editor/components/placeSelector';
import FormikPhoneInput from 'gui/components/formikPhoneInput';
import FormikTextField from 'gui/components/formikTextField';
import SimpleSelector from 'gui/components/simpleSelector';
import {eCompanyClassification} from "../../../../../../../../../../../../data/enums/products";

export const shopClassificationsLabels = [
  {label: 'ספרים', value: eCompanyClassification.books},
  {label: 'לבית', value: eCompanyClassification.house},
  {label: 'חשמל', value: eCompanyClassification.electronics},
  {label: 'מכשירים סלולריים', value: eCompanyClassification.cellphones},
  {label: 'קפה', value: eCompanyClassification.cafe},
  {label: 'אומנות', value: eCompanyClassification.art},
  {label: 'אופנה', value: eCompanyClassification.fashion},
  {label: 'מצרכים', value: eCompanyClassification.groceries},
];

const FieldTypeShop = () => {
  return (
    <>
      <Grid item xs={12} sm={6}>
        <FastField
          label="איזור"
          name="areasPick"
          component={AreaSelectorContainer}
        />
      </Grid>
      <Grid item xs={12} sm={6} style={{display: 'none'}}>
        <FastField
          label="סוג חנות"
          name="companyClassifications"
          component={SimpleSelector}
          isMulti={true}
          options={shopClassificationsLabels}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormikPhoneInput
          label="טלפון"
          name="phone"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormikTextField
          label="אתר"
          name={"websiteUrl"}
          placeholder={"https://www.example.com"}
        />
      </Grid>
      <PlaceSelector
        placeKey={'placeDetails'}
      />
    </>
  );
};

export default React.memo(FieldTypeShop);
